var _defs, _rect, _g, _g2, _polyline, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIDenteqIconsSvg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0d73b2;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 5px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.3,
    y: 21.3,
    width: 99.2,
    height: 81.2,
    rx: 3.3,
    ry: 3.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.1,
    y1: 96,
    x2: 76.7,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.3,
    y1: 89.5,
    x2: 120.5,
    y2: 89.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "38.1 36.6 38.1 75.6 84.4 75.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.1 41.5 38.1 36.6 43.1 41.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "79.4 70.7 84.4 75.6 79.5 80.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.6,
    y1: 75.6,
    x2: 47.6,
    y2: 49.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.8,
    y1: 75.6,
    x2: 55.8,
    y2: 62.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.1,
    y1: 75.6,
    x2: 64.1,
    y2: 56.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.4,
    y1: 75.6,
    x2: 72.4,
    y2: 67.4
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 87.8,
    cy: 47.1,
    rx: 14.1,
    ry: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.9,61.1s3.3,2.7.6,5.3c-2.7,2.6-5.4-.6-5.4-.6-2.7-2.6-4.4-9-4.4-9,0,0,6.5,1.6,9.2,4.3Z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "79.2 102.4 85.7 112.2 56 112.2 62.5 102.4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.2,112.4h37.3c4.3,0,7.8,3.5,7.8,7.8v.3h-52.9v-.3c0-4.3,3.5-7.8,7.8-7.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDenteqIconsSvg03);
export default __webpack_public_path__ + "static/media/IDenteq_Icons_SVG-03.41a2b2eae31d747f6fe438fcd7f803c7.svg";
export { ForwardRef as ReactComponent };